import React from 'react'
import whiteSop from "../assets/media/white-logo.png";
import globeSoccer from "../assets/media/globe-soccer-transparent.png";
import Header from '../components/header';

const Home = () => {
  return (
    <div className='landing-bg'>
      <Header />

      <div className="program" dir="rtl">
        {/* PROGRAM */}
        <h3>برنامج الحفل</h3>

        <ul>
          <li>
            <span className="time">5:30 مساءً:</span>
            <span>فتح الأبواب وبداية السجادة الحمراء</span>
          </li>

          <li>
            <span className="time">7:00 مساءً:</span>
            <span>افتتاح العرض المباشر وملخصات السجادة الحمراء</span>
          </li>

          <li>
            <span className="time">7:05 مساءً:</span>
            <span>
              حفل جوائز الدوري الإسباني (لاليجا – تقديم 5 جوائز على المسرح)
            </span>
          </li>

          <li>
            <span className="time">7:43 مساءً:</span>
            <span>مقابلة VIP – جلسة أسئلة وأجوبة مع نجمين كبيرين</span>
          </li>

          <li>
            <span className="time">8:00 مساءً:</span>
            <span>
              الحفل الرسمي لجوائز Globe Soccer 2025 (حوالي 15 جائزة)
            </span>
          </li>

          <li>
            <span className="time">9:00 مساءً:</span>
            <span>العشاء وحفل Globe Soccer</span>
          </li>
        </ul>

        {/* TRANSPORTATION */}
        <div className="transport" dir="rtl">
          <h3>أوقات المواصلات</h3>

          <ul>
            <li>
              <span className="time">5:00 مساءً:</span>
              <span>من Sofitel إلى Atlantis The Royal</span>
            </li>

            <li>
              <span className="time">10:00 مساءً:</span>
              <span>من Atlantis The Royal إلى Sofitel</span>
            </li>
            <li>
              <span className="time">الزي الرسمي:</span>
              <span>الزي السعودي – أو بدلة رسمية مع ربطة عنق سوداء</span>
            </li>
          </ul>
        </div>
      </div>



      <div className='footer'>
        <img src={whiteSop} alt="logo" width={80} />
        <img src={globeSoccer} alt="logo" width={100} />
      </div>
    </div>
  )
}

export default Home